module.exports = __webpack_public_path__ + "static/media/assured.ee7e4421.png";